
import SEO from './seo.json';

export { SEO };

const login = "noize_mc"
export const TG = {
  links: {
    desktop: `tg://resolve?domain=${login}`,
    mobile: `https://t.me/${login}`
  },
  get link() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return isMobile ? this.links.mobile : this.links.desktop;
  },
};

const botLogin = "HowToNormalnoBot"

export const BOT = {
  links: {
    desktop: `tg://resolve?domain=${botLogin}`,
    mobile: `https://t.me/${botLogin}`
  },
  startProps: {
    mentoring: 'mentoring',
    club: 'club'
  }
};


export const getLink = (startProp) => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  let link = isMobile ? BOT.links.mobile : BOT.links.desktop;
  if (startProp) {
    const prefix = isMobile ? `?` : `&`
    link = link + prefix + `start=${startProp}`
  }
  return link
}

export const MENTORING_LINK =
  "https://career.avito.com/mentors/mariya-burlakova/";

export { SITE_URL } from './site-config';

export const COLORS = {
  accentCyan: "#06b6d4",
  accentIndigo: "#9263f1",
  accentGreen: "rgb(74, 205, 74)",
  accentOrange: "#fb923c",
  accentViolet: "#818cf8",
  accentPink: "rgb(219, 88, 191)",
  accentSky: "#38bdf8",
  accentYellow: "#daf913",
  accentStatus: "#c9ee22",
  cardCorner: "#6366f1",
  cardLine1: "#a763f1",
  cardLine2: "#6366f1",
  white: "#ffffff",
  darkBg: "#030712",
  textGray: "#d1d5db",
  textMuted: "#9ca3af",
  buttonPrimaryShadow: "#06b6d4",
  gradientSubtitleEnd: "#c084fc",
};

const CSS_VAR_MAP = {
  accentCyan: "--color-accent-cyan",
  accentIndigo: "--color-accent-indigo",
  accentGreen: "--color-accent-green",
  accentOrange: "--color-accent-orange",
  accentViolet: "--color-accent-violet",
  accentPink: "--color-accent-pink",
  accentSky: "--color-accent-sky",
  accentYellow: "--color-accent-yellow",
  accentStatus: "--color-accent-status",
  cardCorner: "--color-card-corner",
  cardLine1: "--color-card-line-1",
  cardLine2: "--color-card-line-2",
  white: "--color-white",
  darkBg: "--color-dark-bg",
  textGray: "--color-text-gray",
  textMuted: "--color-text-muted",
  buttonPrimaryShadow: "--color-button-primary-shadow",
  gradientSubtitleEnd: "--color-gradient-subtitle-end",
};

export function applyThemeColors() {
  const root = document.documentElement;
  Object.entries(CSS_VAR_MAP).forEach(([key, cssVar]) => {
    root.style.setProperty(cssVar, COLORS[key]);
  });
}

export const HEADER_ITEMS = [
  { label: "Книжный клуб", href: "#club" },
  { label: "Кто ведёт", href: "#about" },
  { label: "Что читаем", href: "#stack" },
  { label: "Почему нормальный", href: "#whyme" },
  { label: "Записаться", href: "#contacts" },
  { label: "Разобранное", href: "#portfolio" },
  { label: "Менторинг", href: "/mentor" },
];

export const BOOK_TITLES = {
  bug: "Жук в муравейнике",
  "cherry-garden": "Вишнёвый сад",
  collector: "Коллекционер",
  idiot: "Идиот",
  "master-margarita": "Мастер и Маргарита",
  methods: "Гарри Поттер и методы рационального мышления",
  picnic: "Пикник на обочине",
  pride: "Гордость и предубеждение",
};

export const STACK_TOPIC_TO_STACK_ID = {
  "будущее-и-мы-в-нём": "stack-1",
  "человек-и-его-голова": "stack-2",
  "неподъёмные-произведения": "stack-3",
  "хиханьки-хаханьки": "stack-4",
  "заезженное-под-новым-углом": "stack-4",
};
